import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { ApplyNow, TopRatedCompany } from "../../../constants";
import { Job3BoxSlider, RatedJobData, TopRatedCompanyContent } from "../../../data/demo/JobDemo3";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import { routes } from "../../../routers/routes";
import { dynamicImage, dynamicSvg, Image } from "../../../utils";
import SvgIcon from "../../../utils/SvgIcon";
import CommonHeader from "../common/CommonHeader";

const Company = () => {
  const { productItem } = useAppSelector((state) => state.product);
  return (
    <section className="rated-job-section position-relative overflow-x-hidden">
      {RatedJobData.map((item, index) => (item.type === "png" ? <Image src={dynamicImage(item.image)} alt="o-1" className={`img-fluid ${item.class}`} key={index} /> : <Image src={dynamicSvg(item.image)} alt="o-1" className={`img-fluid ${item.class}`} key={index} />))}
      <Container>
        <CommonHeader title={TopRatedCompany} content={TopRatedCompanyContent} headClass="title-style-5" />
        <Swiper {...Job3BoxSlider} className="job3-box-slider">
          {productItem
            .filter(({ id }) => [16, 17, 18, 19, 20, 21, 22].includes(id))
            .map((item, index) => (
              <SwiperSlide key={index}>
                <div className="company-job-box">
                  <div className="company-logo">
                    {item.image.map((imgSrc, idx) => (
                      <Image src={dynamicSvg(imgSrc)} alt={`job-${idx}`} className="img-fluid" key={idx} />
                    ))}
                  </div>
                  <div className="company-content">
                    <Link to={routes.Job.Grid.JobLeftSidebar} className="d-block company-job-title">
                      <h5>{item.company}</h5>
                    </Link>
                    <ul className="hire-list">
                      <li>
                        <SvgIcon iconId="property/sprite/star.svg#star-svg" />
                        {item.rating}
                      </li>
                      <li>{item.location}</li>
                    </ul>
                    <Link to={routes.Job.Grid.JobLeftSidebar} className="d-block">
                      <h5>{item.title}</h5>
                    </Link>
                    <Link to={routes.Pages.Other.ContactUs1} className="btn-solid">
                      {ApplyNow}
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            ))}
        </Swiper>
      </Container>
    </section>
  );
};

export default Company;
